// extracted by mini-css-extract-plugin
module.exports = {"image":"File_image__2CZKi","imgFormContainer":"File_imgFormContainer__10vBM","title":"File_title__cuni1"};